<template>
	<div class="chatroomError">抱歉，你访问的页面不存在。</div>
</template>
<script>
export default {
	name: '400',
	props: [],
	data() {
		return {}
	},
	methods: {}
}
</script>
<style scoped>
.chatroomError {
	font-size: 24px;
	text-align: center;
	margin-top: 10%;
	font-weight: 700;
}
</style>


// WEBPACK FOOTER //
// src/components/errorPage/404.vue